"use client";

import React from "react";
import Image from "next/image";
import "./Steps.css";
import step1 from "@/public/assets/images/step1image-Photoroom.png";
import step2 from "@/public/assets/images/step2image-Photoroom.png";
import step3 from "@/public/assets/images/step3image-Photoroom.png";
import step4 from "@/public/assets/images/step4image-Photoroom.png";

const Steps = () => {
  const steps = [
    {
      id: 1,
      title: "Select Product",
      description: "Pick your favorite product and customize it your way.",
      image: step1,
    },
    {
      id: 2,
      title: "Upload Hidden Video",
      description: "Add photos and a secret video surprise inside.",
      image: step2,
    },
    {
      id: 3,
      title: "We Create Magic",
      description: "We turn your memories into a magical experience.",
      image: step3,
    },
    {
      id: 4,
      title: "Your Gift Ready",
      description: "Receive your gift and enjoy the surprise.",
      image: step4,
    },
  ];

  return (
    <section className="steps-section" id="steps">
      <div className="steps-container">
        <div className="steps-header">
          <h2 className="steps-title">
            Simple Steps To Create Own Augmented Reality
          </h2>
          <p className="steps-subtitle">
            A simple step-by-step process to turn your memories into magical
            gifts.
          </p>
        </div>

        <div className="steps-grid">
          {steps.map((step) => (
            <div key={step.id} className="step-card">
              <div className="step-icon-wrapper">
                <div className="step-circle">
                  <Image
                    src={step.image}
                    alt={step.title}
                    fill
                    style={{ objectFit: "cover" }}
                  />
                </div>
                <div className="step-number-badge">{step.id}</div>
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Steps;
